import '../src/common/style.css'
import Route from '../src/Route/Route';

function App() {
  return (
    <div className="App">
    <Route/>
    
    </div>
  );
}

export default App;
